import { render, staticRenderFns } from "./CarePlanDrawer.vue?vue&type=template&id=67c07df6&scoped=true&"
import script from "./CarePlanDrawer.vue?vue&type=script&lang=ts&"
export * from "./CarePlanDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./CarePlanDrawer.vue?vue&type=style&index=0&id=67c07df6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c07df6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsImageOrFallback: require('/var/www/packages/theme/components/atoms/ImageOrFallback.vue').default,AtomsPrice: require('/var/www/packages/theme/components/atoms/Price.vue').default,IconsCheckmark24px: require('/var/www/packages/theme/components/icons/checkmark/Checkmark24px.vue').default,AtomsFeedbackButton: require('/var/www/packages/theme/components/atoms/FeedbackButton.vue').default,AtomsKEButton: require('/var/www/packages/theme/components/atoms/KEButton.vue').default,AtomsKEDrawer: require('/var/www/packages/theme/components/atoms/KEDrawer.vue').default})
